import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportViewComponent } from './report-view/report-view.component';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { DatePickerComponent } from './date-picker/date-picker.component'; 
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core'; 
import { GridModule } from "@progress/kendo-angular-grid";
import { ExcelExportModule } from "@progress/kendo-angular-excel-export";
import { MatDialogModule } from '@angular/material/dialog';
import { ChartsModule } from '@progress/kendo-angular-charts';

@NgModule({
  declarations: [
    ReportViewComponent,
    DatePickerComponent
  ],
  imports: [
    CommonModule,
    ReportsRoutingModule,
     MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
     MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    GridModule,
    ExcelExportModule,
    MatDialogModule,
    ChartsModule
  ]
})
export class ReportsModule { }
